module.exports = __webpack_public_path__ + "img/qrcode.01666e10.jpg";